import { useStore } from 'react-redux';
import useFigurePanelId from './useFigurePanelId';
import G from './Getters';


const locationCodes = [
  ["tl","tm","tr"],
  ["ml","mm","mr"],
  ["bl","bm","br"],
]

function expandBase(location){
  return {
    alignItems:({t:"start",m:"center",b:"flex-end"})[location[0]],
    justifyContent:({l:"start",m:"center",r:"flex-end"})[location[1]],
  }
}







export default function NodePositionChangeDispatcher({
  onChange, 
  nodeId,
  cellLocation,
  selected,
}){

  /*
  let figurePanelId = useFigurePanelId();
  let store = useStore();
  let state = store.getState();
  */

  

  //this really is the WORST way of doing this
  //
  //let textNodes = document.querySelector(`[cell="${cellLocation.join('-')}"] [nodeid][component=text]`);


  //let thisNodeLocator = {cell:cellLocation,nodeId}; 


  return (
    <div style={{
      zIndex:10000,

      //putting a z-index (100000) here allows the
      //dragged item to move over anything

      //but if we take the z-index out,
      //then we can actually interact
      //with the NodeDropPoints (for 
      //stacking nodes together)
      //and I think those are definitely more important 
      //nodes to interact with...


      opacity:0.5,

    }} class="absolute-cover sg-col">
      {locationCodes.map(row => {
        return (

          <div class="sg-row flex-expand">
            {row.map(item => {
              return (
                <div style={{
                  outline:'1px solid yellow',
                }} class="flex-expand rel">
                  <div 
                    onMouseEnter={() => {

                      let changeObject = {
                        value:{
                          location:item,
                          position:expandBase(item)
                        },
                      }

                      onChange(changeObject);
                    }} style={{
                    pointerEvents:'auto',
                    //border:'1px solid #ddd',
                  }} class="absolute-cover"/>
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )

}
